export default ({ app }) => {
  app.router.beforeEach((to, from, next) => {
    const isPlp = path => path.includes("/collections/");
    const isPdp = path => path.startsWith("/products/");

    const fromPlp = isPlp(from.path);
    const toPlp = isPlp(to.path);

    const fromPdp = isPdp(from.path);
    const toPdp = isPdp(to.path);

    if (fromPlp && toPlp) {
      return next();
    }

    if (fromPlp && toPdp) {
      return next();
    }

    if (fromPdp && toPlp) {
      return next();
    }

    // PLP -> anything else (home, cms, etc.)
    if (fromPlp) {
      app.store.dispatch("productsSearch/dispose");
    }

    next();
  });
};
